export const AMORTIZATION_TYPE = "481c1425-4680-11e9-82f6-0242ac120002";
export const ASSET_CLASS = "28aded29-4719-11e9-a208-0242ac140002";
export const ASSET_TYPE = "28adf712-4719-11e9-a208-0242ac140002";
export const CASHOUT_PROCEEDS_PREFERRED_CONSTRAINT = "96399d07-91d5-49d5-8882-1babfd69cda5";
export const EMAIL_CONFIG = "7febb583-2a1a-11e9-8395-0242ac140002";
export const FIXED_INDICES = "7d1e3436-467d-11e9-82f6-0242ac120002";
export const FLOATING_INDICES = "8fb6d89d-4681-11e9-82f6-0242ac120002";
export const FREQUENCY = "a3e9a5db-4688-11e9-82f6-0242ac120002";
export const HEDGE = "2da3640c-4686-11e9-82f6-0242ac120002";
export const INTEREST_RATE_TYPE = "401e3638-4681-11e9-82f6-0242ac120002";
export const LENDER_TYPE = "e0d04903-4687-11e9-82f6-0242ac120002";
export const LOAN_TYPE = "051297e5-4687-11e9-82f6-0242ac120002";
export const MARKET_VALUE_METHODOLOGY = "4185daac-7901-4be9-b27f-91e9e0499bb7";
export const METROPOLITAN_STATISTICAL_AREA = "28ade5b9-4719-11e9-a208-0242ac140002";
export const MEZZ_FUNDING_STRUCTURE = "004f6920-4696-11e9-82f6-0242ac120002";
export const MEZZ_RATE = "d1924e45-4695-11e9-82f6-0242ac120002";
export const PASS_REASON = "53e7d4a7-468f-11e9-82f6-0242ac120002";
export const PER_MEASUREMENT = "bba57696-4685-11e9-82f6-0242ac120002";
export const PROJECT_TYPE = "28adf9ca-4719-11e9-a208-0242ac140002";
export const RATINGS = "6f95bff5-4686-11e9-82f6-0242ac120002";
export const RECOURSE = "71e81cd9-4683-11e9-82f6-0242ac120002";
export const REGION = "28adeaea-4719-11e9-a208-0242ac140002";
export const STATES = "1eea75da-23cd-11e9-8b22-06643d56dd0c";
export const ZONING = "28adfcfb-4719-11e9-a208-0242ac140002";
export const COLLATERAL = "9ad1d635-7d75-11e9-9c8e-0242ac140002";
export const PAYMENT_ADJUSTMENT = "9ad1d661-7d75-11e9-9c8e-0242ac140002";
export const CALCULATION_ADJUSTMENT = "9ad1d670-7d75-11e9-9c8e-0242ac140002";
export const RESET_ADJUSTMENT = "9ad1d67b-7d75-11e9-9c8e-0242ac140002";
export const RATINGS_TRIGGERS = "9ad1d6f8-7d75-11e9-9c8e-0242ac140002";
export const AGGREGATE_INTEREST_METHODS = "19a9f550-830c-11e9-a53c-0242ac120002";
export const SISENSE_REPORT_DASHBOARDS = "7a382d0d-8597-11ea-ad2a-00ff2e1361dc";
export const SISENSE_REPORT_WIDGETS = "895aa090-dfce-48e9-9b97-bfb9fab990fe";
export const MATURITY_TYPES = "f98a31c3-9bec-11e9-8b5f-00ff12c3b408";
export const DAY_TYPES = "e86003bf-766e-11e9-87b9-0242ac120002";
export const SPREAD_TYPE = "90a3fb14-3365-4f1a-9f1c-10916388e9bf";
export const FIRST_PERIOD_ACCRUALS = "7a831d1a-2a33-4194-859e-2896212e4780";
export const DISCOUNT_METHOD = "10a60eb6-3641-4723-80fb-8bff9e9dd8ba";
export const BASE_INDEXES_FIXED = "fd32a186-5c56-11ec-b9d7-98fa9bde2f84";
export const CONFIGURABLE_URLS = "fb26dd7e-1ccd-11ed-a0f6-027736c5c5ef";
